import React from 'react'
import { Widget, async, fromJSX, any } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'
import { paginationWidget } from '../pagination/paginationWidget'
import { NewsAndEventsOverviewLayout } from './newsAndEventsOverviewLayout'
import { NewsAndEventsOverviewState, newsAndEventsOverviewStateUpdaters } from './newsAndEventsOverviewState'

const filtersToPageTitle = (
  tags?: string[],
  department?: string,
  subDepartment?: string,
  specialist?: string
): string => {
  let data: string[] = tags != undefined ? tags : []
  department != undefined && data.push(department)
  subDepartment != undefined && data.push(subDepartment)
  specialist != undefined && data.push(specialist)

  let s: string = ''
  data.map((item) => (data.indexOf(item) != data.length - 1 ? (s += item + ' & ') : (s += item)))

  return s
}

export const newsAndEventsOverviewWidget =
  (page: number, department?: string, subDepartment?: string, specialist?: string, centrum?: string, tags?: string[]) =>
  (state: NewsAndEventsOverviewState): Widget<Updater<NewsAndEventsOverviewState>> =>
    any<Updater<NewsAndEventsOverviewState>>([
      async<NewsOrEvent[]>(state.newsAndEventsItemsState, items =>
        fromJSX(() => {
          const pageTitle = filtersToPageTitle(tags, department, subDepartment, specialist)
          return (
            <NewsAndEventsOverviewLayout
              index={234234}
              title={pageTitle == '' ? 'Nieuws en meer' : pageTitle}
              breadcrumbs={[
                { title: 'Spaarne Gasthuis', url: '/' },
                { title: 'Nieuws en Agenda', url: '/nieuws-en-agenda' },
              ]}
              items={items}
            />
          )
        })
      ).map(newsAndEventsOverviewStateUpdaters.updateNewsAndEventsItemsState),
      paginationWidget(
        page,
        12,
        (newPage: number) =>
          `/nieuws-en-agenda?${(department ? [`department=${department}`] : [])
            .concat(subDepartment ? [`subdepartment=${subDepartment}`] : [])
            .concat(specialist ? [`specialist=${specialist}`] : [])
            .concat(centrum ? [`centrum=${centrum}`] : [])
            .concat(tags ? tags.map((tag) => `tags=${tag}`) : [])
            .join('&')}&page=${newPage}`
      )(state.paginationState).map(newsAndEventsOverviewStateUpdaters.updateNewsAndEventsCountState),
    ])
